export function PageHero({ eyebrow, title, intro, mark }: { eyebrow: string; title: string; intro: string; mark: string }) {
  return <section className="page-hero"><div className="page-hero-mark" aria-hidden="true">{mark}</div><div><p className="eyebrow">{eyebrow}</p><h1>{title}</h1></div><p className="page-hero-intro">{intro}</p></section>;
}

